<template>
    <button :ref="this.ident"
            :id="this.ident"
            :name="this.ident"
            :class="this.defaultClass + ' close'"
            :value="this.value"
            @click="remove">&times;</button>
</template>

<script>
export default {
    name: "file-upload",

    props: [
        'ident',
        'defaultClass',
        'route',
        'value'
    ],

    methods: {
        remove: function (event) {
            event.preventDefault();

            let parent = this.$refs[this.ident].parentElement.parentElement.parentElement
            let target = this.route
            let data = {
                'ident': this.ident,
                'value': this.value
            }

            let axios = require('axios');

            let config = {
                method: 'post',
                url: target,
                data: data,
            };

            axios(config)
                .then(function (response) {
                    parent.remove()
                })
                .catch(function (error) {
                    console.log(error)
                });
        }
    },
}
</script>
